<hr class="ids-divider -soft" style="margin-top: 10rem" />
<div class="ids-px-10 ids-py-8" style="background: var(--ids_color_bg_base)">
  <div class="ids-px-9 ids-body-text -small">
    <div>
      <p class="ids-pb-2" id="endereco" i18n="@@enderecoRodape">
        {{ endereco }}
      </p>
      <a
        target="_blank"
        (click)="trackGA('botao_termos_de_uso')"
        class="ids-link"
        href="https://www.itau.com.br/seguranca/termos-de-uso/"
        >{{ linkPoliticaPrivacidade }}</a
      >
      <hr class="ids-divider -soft my-3" />
      <div class="container-texto-regulatorio">
        <p
          i18n="@@mensagemRodape"
          *ngFor="let linha of textoParaRenderizar; let indice"
          id="linha_{{ indice }}"
        >
          {{ linha }}
        </p>
        <p class="container-texto-versao-app">
          Versão do aplicativo: {{ appVersion }}
        </p>
      </div>
      <div class="ids-d-flex logotipos">
        <div class="anbima ids-pr-8">
          <img src="./assets/img/imgInternaFundosANBIMA.jpg" />
        </div>
        <div class="como-investir">
          <a
            (click)="trackGA('botao_como_investir')"
            title="Como investir - Anbima"
            href="https://comoinvestir.anbima.com.br/"
            target="_blank"
          >
            <img src="./assets/img/Como-investir.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
